<ng-container *ngIf="permConfig.isViewAllowed">
  <div class="container-fluid">
    <app-page-title title="Templates"></app-page-title>
    <div>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <ul ngbNav #justifiednav="ngbNav" class="nav-pills bg-light rounded nav">
              <li [ngbNavItem]="1">
                <a ngbNavLink>
                  <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
                  <span class="d-none d-sm-block">Invoice</span>
                </a>
                <ng-template ngbNavContent>
                  <ng-template [ngTemplateOutlet]="invoice"></ng-template>
                </ng-template>
              </li>
              <li [ngbNavItem]="2">
                <a ngbNavLink>
                  <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
                  <span class="d-none d-sm-block">Awb</span>
                </a>
                <ng-template ngbNavContent>
                  <ng-template [ngTemplateOutlet]="awb"></ng-template>
                </ng-template>
              </li>
              <li [ngbNavItem]="3">
                <a ngbNavLink>
                  <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
                  <span class="d-none d-sm-block">Manifest</span>
                </a>
                <ng-template ngbNavContent>
                  <ng-template [ngTemplateOutlet]="manifest"></ng-template>
                </ng-template>
              </li>
              <li [ngbNavItem]="4">
                <a ngbNavLink>
                  <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
                  <span class="d-none d-sm-block">Commercial Invoice</span>
                </a>
                <ng-template ngbNavContent>
                  <ng-template [ngTemplateOutlet]="commercialinvoice"></ng-template>
                </ng-template>
              </li>
              <li [ngbNavItem]="5">
                <a ngbNavLink>
                  <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
                  <span class="d-none d-sm-block">DRS</span>
                </a>
                <ng-template ngbNavContent>
                  <ng-template [ngTemplateOutlet]="drs"></ng-template>
                </ng-template>
              </li>
              <li [ngbNavItem]="6">
                <a ngbNavLink>
                  <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
                  <span class="d-none d-sm-block">Box Label</span>
                </a>
                <ng-template ngbNavContent>
                  <ng-template [ngTemplateOutlet]="boxlabel"></ng-template>
                </ng-template>
              </li>
              <li [ngbNavItem]="7">
                <a ngbNavLink>
                  <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
                  <span class="d-none d-sm-block">Label</span>
                </a>
                <ng-template ngbNavContent>
                  <ng-template [ngTemplateOutlet]="label"></ng-template>
                </ng-template>
              </li>
            </ul>
            <div class="card-body">
              <div [ngbNavOutlet]="justifiednav"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <ng-template #invoice>
        <!-- <div class="container"> -->
          <div class="row  g-2">
            <div class="col-md-3 image-options" *ngFor="let template of Invoice;"
              [ngClass]="{ 'selected-template': template.id  === selectedInvoiceTemplate }">
              <div *ngIf="template.id === selectedInvoiceTemplate" class="double-tick">
                <i class='bx bxs-check-circle font-size-20'></i>
              </div>
              <div class="p-3 border border-dark rounded">
                <div class="cards">
                  <img [src]="template.thumbnailimageurl" [alt]="template.filename" class="image-size">
                  <div class="card-buttons">
                    <button type="button" class="btn btn-sm btn-primary" (click)="previewImage(template.id)">
                      <i class="bx bx-show font-size-16 align-middle me-1"></i> Preview
                    </button>
                    <button type="button" class="btn btn-sm btn-success"
                      (click)="setDefault(template.id,template.category)">
                      <i class="bx bx-check font-size-16 align-middle me-1"></i> Set Default
                    </button>
                    <label type="text" class="btn btn-sm btn-light align-middle me-1 no-hover"> {{ template.templatename }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        <!-- </div> -->
      </ng-template>
      <ng-template #awb>
        <!-- <div class="container"> -->
          <div class="row  g-2">
            <div class="col-md-3 image-options" *ngFor="let template of AWB;"
              [ngClass]="{ 'selected-template': template.id  === selectedAWBTemplate }">
              <div *ngIf="template.id === selectedAWBTemplate" class="double-tick">
                <i class='bx bxs-check-circle font-size-20'></i>
              </div>
              <div class="p-3 border border-dark rounded">
                <div class="cards">
                  <img [src]="template.thumbnailimageurl" [alt]="template.filename" class="image-size">
                  <div class="card-buttons">
                    <button type="button" class="btn btn-sm btn-primary" (click)="previewImage(template.id)">
                      <i class="bx bx-show font-size-16 align-middle me-1"></i> Preview
                    </button>
                    <button type="button" class="btn btn-sm btn-success"
                      (click)="setDefault(template.id,template.category)">
                      <i class="bx bx-check font-size-16 align-middle me-1"></i> Set Default
                    </button>
                    <label type="text" class="btn btn-sm btn-light align-middle me-1 no-hover"> {{ template.templatename }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        <!-- </div> -->
      </ng-template>
      <ng-template #manifest>
        <!-- <div class="container"> -->
          <div class="row  g-2">
            <div class="col-md-3 image-options" *ngFor="let template of Manifest;"
              [ngClass]="{ 'selected-template': template.id  === selectedManifestTemplate }">
              <div *ngIf="template.id === selectedManifestTemplate" class="double-tick">
                <i class='bx bxs-check-circle font-size-20'></i>
              </div>
              <div class="p-3 border border-dark rounded">
                <div class="cards">
                  <img [src]="template.thumbnailimageurl" [alt]="template.filename" class="image-size">
                  <div class="card-buttons">
                    <button type="button" class="btn btn-sm btn-primary" (click)="previewImage(template.id)">
                      <i class="bx bx-show font-size-16 align-middle me-1"></i> Preview
                    </button>
                    <button type="button" class="btn btn-sm btn-success"
                      (click)="setDefault(template.id,template.category)">
                      <i class="bx bx-check font-size-16 align-middle me-1"></i> Set Default
                    </button>
                    <label type="text" class="btn btn-sm btn-light align-middle me-1 no-hover"> {{ template.templatename }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        <!-- </div> -->
      </ng-template>
      <ng-template #commercialinvoice>
        <!-- <div class="container"> -->
          <div class="row  g-2">
            <div class="col-md-3 image-options" *ngFor="let template of CommercialInvoice;"
              [ngClass]="{ 'selected-template': template.id  === selectedCommercialTemplate }">
              <div *ngIf="template.id === selectedCommercialTemplate" class="double-tick">
                <i class='bx bxs-check-circle font-size-20'></i>
              </div>
              <div class="p-3 border border-dark rounded">
                <div class="cards">
                  <img [src]="template.thumbnailimageurl" [alt]="template.filename" class="image-size">
                  <div class="card-buttons">
                    <button type="button" class="btn btn-sm btn-primary" (click)="previewImage(template.id)">
                      <i class="bx bx-show font-size-16 align-middle me-1"></i> Preview
                    </button>
                    <button type="button" class="btn btn-sm btn-success"
                      (click)="setDefault(template.id,template.category)">
                      <i class="bx bx-check font-size-16 align-middle me-1"></i> Set Default
                    </button>
                    <label type="text" class="btn btn-sm btn-light align-middle me-1 no-hover"> {{ template.templatename }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        <!-- </div> -->
      </ng-template>
      <ng-template #drs>
        <!-- <div class="container"> -->
          <div class="row  g-2">
            <div class="col-md-3 image-options" *ngFor="let template of DRS;"
              [ngClass]="{ 'selected-template': template.id  === selectedDRSTemplate }">
              <div *ngIf="template.id === selectedDRSTemplate" class="double-tick">
                <i class='bx bxs-check-circle font-size-20'></i>
              </div>
              <div class="p-3 border border-dark rounded">
                <div class="cards">
                  <img [src]="template.thumbnailimageurl" [alt]="template.filename" class="image-size">
                  <div class="card-buttons">
                    <button type="button" class="btn btn-sm btn-primary" (click)="previewImage(template.id)">
                      <i class="bx bx-show font-size-16 align-middle me-1"></i> Preview
                    </button>
                    <button type="button" class="btn btn-sm btn-success"
                      (click)="setDefault(template.id,template.category)">
                      <i class="bx bx-check font-size-16 align-middle me-1"></i> Set Default
                    </button>
                    <label type="text" class="btn btn-sm btn-light align-middle me-1 no-hover"> {{ template.templatename }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        <!-- </div> -->
      </ng-template>
      <ng-template #boxlabel>
        <!-- <div class="container"> -->
          <div class="row g-2">
            <div class="col-md-3 image-options" *ngFor="let template of BoxLabel;"
              [ngClass]="{ 'selected-template': template.id  === selectedBoxTemplate }">
              <div *ngIf="template.id === selectedBoxTemplate" class="double-tick">
                <i class='bx bxs-check-circle font-size-20'></i>
              </div>
              <div class="p-3 border border-dark rounded">
                <div class="cards">
                  <img [src]="template.thumbnailimageurl" [alt]="template.filename" class="image-size">
                  <div class="card-buttons">
                    <button type="button" class="btn btn-sm btn-primary" (click)="previewImage(template.id)">
                      <i class="bx bx-show font-size-16 align-middle me-1"></i> Preview
                    </button>
                    <button type="button" class="btn btn-sm btn-success"
                      (click)="setDefault(template.id,template.category)">
                      <i class="bx bx-check font-size-16 align-middle me-1"></i> Set Default
                    </button>
                    <label type="text" class="btn btn-sm btn-light align-middle me-1 no-hover"> {{ template.templatename }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        <!-- </div> -->
      </ng-template>
      <ng-template #label>
        <!-- <div class="container"> -->
          <div class="row  g-2">
            <div class="col-md-3 image-options" *ngFor="let template of Label;"
              [ngClass]="{ 'selected-template': template.id  === selectedLabelTemplate }">
              <div *ngIf="template.id === selectedLabelTemplate" class="double-tick">
                <i class='bx bxs-check-circle font-size-20'></i>
              </div>
              <div class="p-3 border border-dark rounded">
                <div class="cards">
                  <img [src]="template.thumbnailimageurl" [alt]="template.templatename" class="image-size">
                  <div class="card-buttons">
                    <button type="button" class="btn btn-sm btn-primary" (click)="previewImage(template.id)">
                      <i class="bx bx-show font-size-16 align-middle me-1"></i> Preview
                    </button>
                    <button type="button" class="btn btn-sm btn-success"
                      (click)="setDefault(template.id,template.category)">
                      <i class="bx bx-check font-size-16 align-middle me-1"></i> Set Default
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        <!-- </div> -->
      </ng-template>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="!permConfig.isViewAllowed">
    <app-forbidden></app-forbidden>
</ng-container>
